export interface GroupGridClass {
  container: string;
  grid: string;
}

export function groupGridClass(count: number): GroupGridClass {
  if (count === 1) {
    return { container: 'max-w-md mx-auto', grid: 'grid grid-cols-1 gap-6' };
  }
  if (count === 2) {
    return { container: 'max-w-4xl mx-auto', grid: 'grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-2' };
  }
  return { container: 'max-w-6xl mx-auto', grid: 'grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3' };
}
